<script>
import Layout from '@layouts/main.vue'
import GeneralFileList from '@components/general/general-file-list.vue'
import GeneralFilePreview from '@components/general/general-file-preview.vue'

export default {
  name: 'HelpView',
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [{ name: 'description', content: 'The Help page.' }],
    }
  },
  components: { Layout, GeneralFileList, GeneralFilePreview },
  data() {
    return {
      showDownloadDialog: false,
      filePath: '',
    }
  },
  methods: {
    downloadFile(file) {
      // preview and download file here
      this.showDownloadDialog = true
      this.filePath = file.filePath
    },
  },
}
</script>

<template>
  <Layout>
    <BasePageTitle :title="$t('help.pageTitle')" />

    <header>
      <h6 class="text-h6">{{ $t('layout.generalFilesListTitle') }}</h6>
    </header>
    <GeneralFileList class="mt-4" @downloadGeneralFile="downloadFile" />
    <GeneralFilePreview :show.sync="showDownloadDialog" :file-path="filePath" />
  </Layout>
</template>
